import { render, staticRenderFns } from "./MyCollect.vue?vue&type=template&id=15b2cfa7&scoped=true&"
import script from "./MyCollect.vue?vue&type=script&lang=js&"
export * from "./MyCollect.vue?vue&type=script&lang=js&"
import style0 from "./MyCollect.vue?vue&type=style&index=0&id=15b2cfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2cfa7",
  null
  
)

export default component.exports